module.exports = __webpack_public_path__ + "img/carro-compra-feliz.ed9e8b8a.webp";